import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components';
import { DEFAULT_PURCHASE_CYCLE } from '../utils/consts';
import { useCycleAvailability } from './useCycleAvailability';
export const useSelectedCycle = () => {
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    isCycleAvailable,
    lowestCycleAvailable
  } = useCycleAvailability(selectedProductId || undefined, selectedCycle || undefined);
  if (!selectedCycle || !isCycleAvailable) {
    const cycle = CycleUtils.maxCycle([lowestCycleAvailable, DEFAULT_PURCHASE_CYCLE]);
    module.SDK.PackagePickerStore.setSelectedCycleId(CycleUtils.convertCycleToCycleId(cycle || DEFAULT_PURCHASE_CYCLE));
    return cycle;
  }
  return selectedCycle;
};
//# sourceMappingURL=useSelectedCycle.js.map